
import Vue from "vue";
import EmptyContent from "@/components/EmptyContent";

export default Vue.extend({
  name: "MessageThreadsEmptyView",
  functional: true,
  props: { hasFilter: { type: Boolean, default: false } },
  render(h, { parent, props }) {
    return h(EmptyContent, {
      staticClass: "message-threads-empty",
      props: { text: props.hasFilter ? parent.$t("No results") : parent.$t("No messages yet") },
    });
  },
});
